import { render, staticRenderFns } from "./Flashlight.vue?vue&type=template&id=c6158e38&scoped=true&"
import script from "./Flashlight.vue?vue&type=script&lang=js&"
export * from "./Flashlight.vue?vue&type=script&lang=js&"
import style0 from "./Flashlight.vue?vue&type=style&index=0&id=c6158e38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6158e38",
  null
  
)

export default component.exports